export default class NoPaymentSessionDataFoundError extends Error
{
    constructor(message?: string)
    {
        super(message);
        this.name = 'NoPaymentSessionDataFoundError';
    }
}
